import { Route } from '@angular/router';
import { AppLayoutComponent } from './components/layout/app.layout.component';
import { loginGuard } from './guards/login.guard';
import { HomeComponent } from './pages/home/home';
import { ImportComponent } from './pages/import/import';
import { LoginComponent } from './pages/onboarding/login/login';
import { NewPasswordComponent } from './pages/onboarding/new-password/new-password';
import { RecoveryComponent } from './pages/onboarding/recovery/recovery';
import { FidelityComponent } from './pages/fidelity/fidelity.component';

export const routes: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard()],
  },
  {
    path: 'recovery',
    component: RecoveryComponent,
    canActivate: [loginGuard()],
  },
  {
    path: 'new-password',
    component: NewPasswordComponent,
    canActivate: [loginGuard()],
  },
  {
    path: 'dashboard',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'import',
        component: ImportComponent,
      },
      {
        path: 'fidelity',
        component: FidelityComponent,
      },
    ],
  },
];
